module.exports = __webpack_public_path__ + "img/ngo_story.67f2ac00.png";